import styled from 'styled-components';
import { media, space, rems } from '../../ui/helpers';
import { colors } from '../../ui/design-tokens';
import fonts from '../../ui/fonts';

  const Block = styled.div<{ textColor: string }>`
    text-align: center;
    padding: 30px 24px 50px 24px; // padding para móvil
    background: ${({ theme }) => theme.background};

    ${media.min('medium')`
      padding: ${space(6)} 0 ${space(12)} 0; // padding original para desktop
    `}

  .subtitle {
    padding: ${space(3)} 0 0 0;
    font-size: 45px; // tamaño titulo
    font-weight: 300; // peso de fuente 
    line-height: 1.1;
  }
  .wysiwyg {
    max-width: 984px;
    padding: ${space(3)} 0 0 0;

    h2,
    h3 {
      ${fonts.titleMD};
    }

    p {
      ${fonts.bodyLG};
    }

    &.coloredText {
      color: ${({ textColor }) => colors[textColor][400]} !important;
    }

    ${media.min('medium')`
      padding: ${space(4)} 0 0 0;
      p {
       ${fonts.bodyMD}; // tamaño de texto para el parrafo
      }
    `}
  }

  ${media.min('medium')`
    margin: 0 300px;
  `}
`;

export { Block };
